import { valueActionCreator } from "../action_creators";
export var SET_STUDENT_APPLICATIONS = 'SET_STUDENT_APPLICATIONS';
export var SET_APPLICATION_INTAKE = 'SET_APPLICATION_INTAKE';
export var REMOVE_APPLICATION = 'REMOVE_APPLICATION';
export var SET_STUDENT_APPLICATIONS_ERROR = 'SET_STUDENT_APPLICATIONS_ERROR';
export var SET_SELECTED_APPLICATIONS = 'SET_SELECTED_APPLICATIONS';
export var setStudentApplications = valueActionCreator(SET_STUDENT_APPLICATIONS);
export var setApplicationIntake = function setApplicationIntake(appId, intake, intakeEsl) {
  return {
    type: SET_APPLICATION_INTAKE,
    appId: appId,
    intake: intake,
    intakeEsl: intakeEsl
  };
};
export var removeApplication = function removeApplication(appId) {
  return {
    type: REMOVE_APPLICATION,
    appId: appId
  };
};
export var setStudentApplicationsError = function setStudentApplicationsError(key, value) {
  return {
    type: SET_STUDENT_APPLICATIONS_ERROR,
    key: key,
    value: value
  };
};
export var setSelectedApplications = valueActionCreator(SET_SELECTED_APPLICATIONS);